import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { Clock3 } from 'lucide-react';
import { cn } from '@/utils/cn';

/**
 * RecTag — the neutral skill/topic chip on the recommendation program cards: `surface-subtle` fill +
 * primary text, Inter label-md (12/14, medium), fully rounded pill. This is a DIFFERENT chip from the
 * shared <PillTag/> (whose brand/meta/outline/warning variants have none of them the neutral
 * surface-subtle fill the program cards use), so it lives here as an exit-screen-local atom rather
 * than mutating the shared one.
 *
 * Built ONLY against fs-* tokens. Imported by direct path from `recommendations.tsx` — NOT via the
 * `_components` barrel.
 */
export function RecTag(t0) {
  const $ = _c(5);
  const {
    children,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("inline-flex items-center justify-center rounded-fs-pill bg-fs-surface-subtle px-fs-sm py-fs-xxs font-medium text-[12px] text-fs-text leading-[14px]", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <span className={t1}>{children}</span>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}

/**
 * DurationTag — the program LENGTH chip (e.g. "8 weeks"). Deliberately a DIFFERENT color from the
 * neutral skill chips (brand-green `fs-brand-subtle` fill + `fs-brand` text + a clock glyph) and
 * rendered on its OWN line so the duration reads as program meta, not a skill.
 */
export function DurationTag(t0) {
  const $ = _c(6);
  const {
    children,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("inline-flex items-center gap-1 rounded-fs-pill bg-fs-brand-subtle px-fs-sm py-fs-xxs font-medium text-[12px] text-fs-brand leading-[14px]", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Clock3 aria-hidden={true} className="h-3 w-3" strokeWidth={2} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== children || $[4] !== t1) {
    t3 = <span className={t1}>{t2}{children}</span>;
    $[3] = children;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}